/** Textos padrão do ConfirmDialog. */
export const CONFIRM_ACCEPT_LABEL = "Confirmar";
export const CONFIRM_REJECT_LABEL = "Cancelar";
export const CONFIRM_ERROR_FALLBACK = "Não foi possível concluir a operação.";
